import React, { useState, useEffect } from "react";
import AdminDrawer from "../../components/AdminDrawer";
import Navbar from "../../components/Navbar";
import {
  Grid,
  Typography,
  Button,
  Stack,
  Modal,
  TextField,
  Box,
  Paper,
  ListItem,
  Chip,
} from "@mui/material";
import GeneralSkeletons from "../../components/GeneralSkeletons";
import {
  addCategory,
  getAllCategories,
  updateCategory,
  deleteCategory,
} from "../../apis";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";

const style = {
  position: "absolute",
  top: "25%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "white",
  p: 4,
};

const CategoriesManager = () => {
  const [open, setOpen] = useState(false);
  const [updateOpen, setUpdateOpen] = useState(false);
  const [subCategories, setSubCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [enteredSubCategory, setEnteredSubCategory] = useState("");
  const [categoryName, setCategoryName] = useState("");
  const [categoriesData, setCategoriesData] = useState([]);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      const response = await getAllCategories();
      setCategoriesData(response.data.categories);
      setLoading(false);
    };
    fetchData();
  }, []);

  const handleClose = () => setOpen(false);
  const handleUpdateClose = () => setUpdateOpen(false);

  const handleDelete = (chipToDelete) => () => {
    setSubCategories((chips) =>
      chips.filter((chip) => chip.key !== chipToDelete.key)
    );
  };

  const addCategoryHandler = async () => {
    if (categoryName == "") {
      setError(true);

      setErrorMessage("Please fill all of the required information.");
    } else {
      const response = await addCategory({
        name: categoryName,
        subCategories: subCategories,
      });
      if (response.data.added == true) {
        setOpen(false);
        const result = await getAllCategories();
        setCategoriesData(result.data.categories);
      } else {
        setError(true);

        setErrorMessage("This Category already exist");
      }
    }
  };

  const clickhandler = (id) => {
    const filteredResult = categoriesData.filter((item) => item._id == id);
    setSubCategories(filteredResult[0].subCategories);
    setCategoryName(filteredResult[0].name);
    setEnteredSubCategory("");
    setUpdateOpen(true);
  };

  const updateClickHandler = async () => {
    setError(false);
    const filteredResult = categoriesData.filter(
      (item) => item.name == categoryName
    );
    const response = await updateCategory({
      subCategories: subCategories,
      id: filteredResult[0]._id,
    });
    if (response.data.updated == true) {
      setUpdateOpen(false);
      const result = await getAllCategories();
      setCategoriesData(result.data.categories);
    }
  };

  const deleteClickHandler = async () => {
    const filteredResult = categoriesData.filter(
      (item) => item.name == categoryName
    );
    const response = await deleteCategory({
      id: filteredResult[0]._id,
    });
    if (response.data.deleted == true) {
      setUpdateOpen(false);
      const result = await getAllCategories();
      setCategoriesData(result.data.categories);
    }
  };

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Stack spacing={2}>
            {error ? (
              <Stack>
                <Typography style={{ color: "red" }}>{errorMessage}</Typography>
              </Stack>
            ) : (
              <></>
            )}
            <Stack>
              <Typography style={{ fontWeight: "bold" }}>
                Add Category
              </Typography>
            </Stack>
            <Stack>
              <Typography>Name</Typography>
              <TextField
                size="small"
                id="outlined-basic"
                placeholder="Enter Category Name"
                variant="outlined"
                className="w-100 mt-5"
                value={categoryName}
                onChange={(e) => setCategoryName(e.target.value)}
              />
            </Stack>
            {/* <Stack>
              <Typography>Sub Categories</Typography>
              <TextField
                size="small"
                id="outlined-basic"
                placeholder="Enter your email address"
                variant="outlined"
                className="w-100 mt-5"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Stack> */}
            {subCategories.length ? (
              <Stack>
                <Paper
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    flexWrap: "wrap",
                    listStyle: "none",
                    p: 0.5,
                    m: 0,
                  }}
                  // component="ul"
                  style={{ display: "flex", flexDirection: "row" }}
                >
                  {subCategories.map((data) => {
                    return (
                      <Chip
                        label={data.label}
                        onDelete={handleDelete(data)}
                        className="ml-4"
                      />
                    );
                  })}
                </Paper>
              </Stack>
            ) : (
              <></>
            )}

            <Stack>
              <Typography className="registration-label">
                Enter Sub Categories
              </Typography>
              <TextField
                required
                id="outlined-basic"
                variant="outlined"
                className="w-100 "
                size="small"
                value={enteredSubCategory}
                onChange={(e) => setEnteredSubCategory(e.target.value)}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    let obj = {
                      key:
                        subCategories.length > 0
                          ? subCategories[subCategories.length - 1].key + 1
                          : 1,
                      label: enteredSubCategory,
                      value: enteredSubCategory,
                    };
                    setSubCategories((previous) => [...previous, obj]);
                    setEnteredSubCategory("");
                  }
                }}
                placeholder="Enter Sub Categories here"
              />
            </Stack>

            <Stack direction="row" justifyContent="flex-end" spacing={2}>
              <Button
                variant="outlined"
                className="default-color default-border"
                style={{ textTransform: "capitalize" }}
                onClick={handleClose}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                className="primary-button"
                style={{ textTransform: "capitalize" }}
                onClick={addCategoryHandler}
              >
                Add
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Modal>

      <Modal
        open={updateOpen}
        onClose={handleUpdateClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Stack spacing={2}>
            {/* {modalError ? (
              <Stack>
                <Typography style={{ color: "red" }}>{errorMessage}</Typography>
              </Stack>
            ) : (
              <></>
            )} */}
            <Stack direction="row" justifyContent="space-between">
              <Typography style={{ fontWeight: "bold" }}>
                Update Category
              </Typography>
              <DeleteOutlineOutlinedIcon
                onClick={deleteClickHandler}
                style={{ cursor: "pointer" }}
              />
            </Stack>
            <Stack>
              <Typography>Name</Typography>
              <TextField
                size="small"
                id="outlined-basic"
                placeholder="Enter Category Name"
                variant="outlined"
                className="w-100 mt-5"
                value={categoryName}
                disabled
                onChange={(e) => setCategoryName(e.target.value)}
              />
            </Stack>
            {/* <Stack>
              <Typography>Sub Categories</Typography>
              <TextField
                size="small"
                id="outlined-basic"
                placeholder="Enter your email address"
                variant="outlined"
                className="w-100 mt-5"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Stack> */}
            {subCategories.length ? (
              <Stack>
                <Paper
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    flexWrap: "wrap",
                    listStyle: "none",
                    p: 0.5,
                    m: 0,
                  }}
                  // component="ul"
                  style={{ display: "flex", flexDirection: "row" }}
                >
                  {subCategories.map((data) => {
                    return (
                      <Chip
                        label={data.label}
                        onDelete={handleDelete(data)}
                        className="ml-4"
                      />
                    );
                  })}
                </Paper>
              </Stack>
            ) : (
              <></>
            )}

            <Stack>
              <Typography className="registration-label">
                Enter Sub Categories
              </Typography>
              <TextField
                required
                id="outlined-basic"
                variant="outlined"
                className="w-100 "
                size="small"
                value={enteredSubCategory}
                onChange={(e) => setEnteredSubCategory(e.target.value)}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    let obj = {
                      key:
                        subCategories.length > 0
                          ? subCategories[subCategories.length - 1].key + 1
                          : 1,
                      label: enteredSubCategory,
                      value: enteredSubCategory,
                    };
                    setSubCategories((previous) => [...previous, obj]);
                    setEnteredSubCategory("");
                  }
                }}
                placeholder="Enter Sub Categories here"
              />
            </Stack>

            <Stack direction="row" justifyContent="flex-end" spacing={2}>
              <Button
                variant="outlined"
                className="default-color default-border"
                style={{ textTransform: "capitalize" }}
                onClick={handleUpdateClose}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                className="primary-button"
                style={{ textTransform: "capitalize" }}
                onClick={updateClickHandler}
              >
                Update
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Modal>

      <Navbar />
      <div className="ml-16">
        <Grid container rowSpacing={2} columnSpacing={4} className="mt-10">
          <Grid item xs={2}>
            <AdminDrawer page="Categories Manager" />
          </Grid>
          <Grid item xs={10}>
            <Grid container>
              <Grid item sm={9}>
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  className="mb-16"
                >
                  <Typography variant="h6">Categories Manager</Typography>
                  <Button
                    className="primary-button"
                    variant="contained"
                    style={{ textTransform: "capitalize" }}
                    onClick={() => {
                      setOpen(true);
                      setCategoryName("");
                      setSubCategories([]);
                      setEnteredSubCategory("");
                      setError(false);
                    }}
                  >
                    Add New
                  </Button>
                </Stack>
                <div
                  style={{ border: "1px solid #EEEBEF", borderRadius: "6px" }}
                  className="mb-16"
                >
                  <Stack spacing={2}>
                    {categoriesData.length && loading == false ? (
                      categoriesData.map((item) => (
                        <div
                          style={{
                            borderBottom: "1px solid #EEEBEF",
                            marginTop: "20px",
                            paddingBottom: "20px",
                            paddingLeft: "20px",
                            cursor: "pointer",
                          }}
                          onClick={() => clickhandler(item._id)}
                        >
                          <Typography
                            style={{
                              fontWeight: "bold",
                              textTransform: "capitalize",
                            }}
                          >
                            {item.name}
                          </Typography>
                        </div>
                      ))
                    ) : categoriesData.length == 0 && loading == false ? (
                      <>
                        <Typography>No Categories Found</Typography>
                      </>
                    ) : (
                      <>
                        <GeneralSkeletons />
                        <GeneralSkeletons />
                        <GeneralSkeletons />
                        <GeneralSkeletons />
                        <GeneralSkeletons />
                      </>
                    )}
                  </Stack>
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default CategoriesManager;
